export enum LoggerEcl {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}
